<script module lang="ts">
  import type { Props as BoxProps } from '../boxes/Box.svelte';
  import type { HTMLFormAttributes } from 'svelte/elements';

  export type Props = Omit<BoxProps, 'tag'> & Pick<HTMLFormAttributes, 'action' | 'method' | 'novalidate' | 'enctype' | 'autocomplete'>;
</script>

<script lang="ts">
  import Box from '../boxes/Box.svelte';

  const props: Props = $props();
</script>

<Box {...props} tag="form" />
